<template>
  <div class="plc-price-list-page">
    <!-- 第一部分：标题 -->
    <div class="header-section">
      <div class="page-title" style="color: #ff3176;">{{ detailInfo.title || '' }}</div>
      <div class="page-subtitle">有效期：{{ detailInfo.validity_date || '' }} ~ {{ detailInfo.expiry_date || '' }}</div>
    </div>

    <!-- 第二部分：搜索区域 -->
    <div class="search-section">
      <!-- Tab 切换 -->
      <div class="tab-bar">
        <div
          v-for="tab in tabList"
          :key="tab.value"
          class="tab-item"
          :class="{ active: activeTab === tab.value }"
          @click="handleTabChange(tab.value)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined && tab.count !== null && tab.count > 0"
                class="tab-badge">{{ tab.count > 99 ? '99+' : tab.count }}</span>
        </div>
      </div>

      <!-- 搜索条件 -->
      <div class="search-form">
        <el-form :model="searchCondition" inline size="mini">
          <el-form-item>
            <select-artist :value.sync="searchCondition.artist_id" placeholder="输入昵称关键词查找红人"
                           style="width: 100%" @change="handleSearch" />
          </el-form-item>
          <el-form-item class="platform-tabs">
            <el-radio-group v-model="searchCondition.platform_code" @change="handleSearch">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button
                v-for="platform in platformList"
                :key="platform.platform_code"
                :label="platform.platform_code"
              >
                {{ platform.platform_name }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="searchCondition.onlyMine" @change="handleSearch">仅查看我的</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 第三部分：列表 -->
    <div class="table-section">
      <el-table
        :data="dataList"
        v-loading="loadingStatus"
        element-loading-text="加载中……"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
      >
        <el-table-column label="提报ID" align="center" prop="id" width="80"></el-table-column>
        <el-table-column label="红人" align="center" min-width="200">
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;padding-left: 20px;">
              <el-avatar :src="row.cover_pc_url" :size="60" shape="circle">
                <i class="el-icon-user-solid" style="font-size: 20px; color: #c0c4cc;"></i>
              </el-avatar>
              <div style="margin-left: 10px;font-weight: 500;color: #212133">{{ row.nickname || '/' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提报平台" align="center" min-width="100">
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;padding-left: 20px;">
              <platform-img :code="row.platform_code" :name="row.platform_name" style="margin-right: 10px;" />
              <span>{{ row.platform_name || '/' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提报时间" align="center" min-width="220">
          <template slot-scope="{ row }">
            <div><span style="color: #585b6b;">提报时间：</span>{{ row.created_at }}</div>
            <div><span style="color: #585b6b;">修改时间：</span>{{ row.updated_at }}</div>
          </template>
        </el-table-column>
        <el-table-column label="定价状态" align="center" width="140">
          <template slot-scope="{ row }">
            <status-plc-price :obj="row" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.status === 1"
              type="primary"
              size="mini"
              @click="handleGoPricing(row)"
            >
              去定价
            </el-button>
            <el-button
              v-else-if="row.status === 2&&row.apply_status!==2"
              type="warning"
              size="mini"
              @click="handleGoPricing(row)"
            >
              申请改价
            </el-button>
            <el-button v-else size="mini" @click="handleGoPricing(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 空状态 -->
      <div v-if="!loadingStatus && dataList.length === 0" class="empty-state">
        <el-empty description="暂无数据" />
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <m-pagination
          :limit.sync="pageData.page_size"
          :page.sync="pageData.current_page"
          :total.sync="pageData.total"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlatformImg from '../../../components/PlatformImg/index.vue'
import SelectArtist from '../../../components/select/artist.vue'
import { commonSearchCondition } from '../../../utils'
import { detailForPriceList } from '../../../api/plc'
import StatusPlcPrice from '../../../enum/plc/tag/status-price.vue'

export default {
  name: 'PlcPriceList',
  components: { StatusPlcPrice, SelectArtist, PlatformImg },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  data() {
    return {
      pm_id: 0,
      // 详情信息（从 detailForPriceList 获取）
      detailInfo: {},
      // 平台列表（从 detailForPriceList 获取）
      platformList: [],
      // 平台总数
      platformTotal: 0,
      // 定价状态计数（从 detailForPriceList 获取）
      statusCount: {},
      // Tab 列表
      tabList: [
        { label: '待定价', value: 'pending', count: null },
        { label: '改价中', value: 'changing', count: null },
        { label: '已定价', value: 'priced', count: null },
        { label: '全部', value: 'all', count: null }
      ],
      activeTab: 'pending',
      // 搜索条件（status / apply_status 由 Tab 切换驱动，必须预先声明以保证 Vue2 响应式）
      searchCondition: {
        artist_id: '',
        platform_code: '',
        onlyMine: false,
        status: '',
        apply_status: ''
      },
      // 列表数据
      dataList: [],
      loadingStatus: false,
      // 分页信息
      pageData: {
        total: 0,
        page_size: 15,
        current_page: 1
      }
    }
  },
  created() {
    this.pm_id = this.$route.query.pm_id
    this.getDetail()
    this.getList()
  },
  methods: {
    getDetail: async function() {
      try {
        const response = await detailForPriceList(this.pm_id)
        if (response) {
          // 赋值详情信息
          if (response.info) {
            this.detailInfo = response.info
          }
          // 赋值平台列表
          if (response.platforms) {
            this.platformList = response.platforms
            this.platformTotal = response.platforms.reduce((sum, p) => sum + (p.num || 0), 0)
          }
          // 赋值定价状态计数（将 status_wait/status_done/status_apply 映射为 pending/priced/changing）
          if (response.status) {
            const statusMap = {
              status_wait: 'pending',
              status_done: 'priced',
              status_apply: 'changing'
            }
            const mapped = {}
            Object.keys(response.status).forEach(key => {
              const mappedKey = statusMap[key]
              if (mappedKey) {
                mapped[mappedKey] = response.status[key]
              }
            })
            this.statusCount = mapped
            this.applyTabCounts(mapped)
          }
        }
      } catch (e) {
        console.error('获取详情失败', e)
      }
    },
    // 统一更新 tab-bar 各 tab 的气泡数
    // counts 形如 { pending, changing, priced, all }，缺省的状态按 0 处理
    applyTabCounts(counts) {
      const source = counts || {}
      this.tabList = this.tabList.map(tab => ({
        ...tab,
        count: Number(source[tab.value]) || 0
      }))
    },
    // Tab 切换
    handleTabChange(tabValue) {
      this.activeTab = tabValue
      this.pageData.current_page = 1
      this.getList()
    },
    // 搜索
    handleSearch() {
      this.pageData.current_page = 1
      this.getList()
    },
    // 根据当前 Tab 生成状态筛选条件
    // 每次调用都从零构建，避免上一次 Tab 的条件残留
    buildTabCondition() {
      switch (this.activeTab) {
        case 'pending':
          return { status: 1 }
        case 'changing':
          return { apply_status: 2 }
        case 'priced':
          return { status: 2 }
        default:
          // 「全部」不带任何状态条件
          return {}
      }
    },
    handleSearchCondition() {
      const { artist_id, platform_code, onlyMine } = this.searchCondition
      // 基础查询条件：只带上真正有值的字段
      const condition = {
        pm_id: this.pm_id,
        current_page: this.pageData.current_page,
        page_size: this.pageData.page_size,
        order: { nickname: 'desc', id: 'desc' },
        ...this.buildTabCondition()
      }
      if (artist_id) {
        condition.artist_id = artist_id
      }
      if (platform_code) {
        condition.platform_code = platform_code
      }
      if (onlyMine) {
        condition.user_id = this.userInfo.id
      }
      return commonSearchCondition(condition)
    },
    // 获取列表数据
    async getList() {
      this.loadingStatus = true
      try {
        const params = this.handleSearchCondition()
        const { list, pages, counts } = await this.$api.getPublicationItemList(params)
        this.dataList = list || []
        // 兼容后端返回 pages / total 两种分页结构
        this.pageData.total = pages?.total || 0
        // 更新各 Tab 的计数（后端返回 counts 时优先使用，否则保留 getDetail 的结果）
        if (counts) {
          this.applyTabCounts(counts)
        }
      } catch (e) {
        this.$message.error('获取列表失败')
      } finally {
        setTimeout(() => {
          this.loadingStatus = false
        }, 100)
      }
    },
    // 去定价（新开窗口，保留列表页筛选状态）
    handleGoPricing(row) {
      const windowTarget = `plc_do_priced_${row.artist_id}_${row.platform_code}`
      const windowFeatures = 'left=50,top=50,width=1200,height=900'
      this.$utils.safeOpenWindow(this, {
        name: 'plc_do_priced',
        query: {id:row.id, journal_id: row.journal_id, pm_id: row.pm_id, artist_id: row.artist_id, platform_code: row.platform_code }
      }, windowTarget, windowFeatures)
    }
  }
}
</script>

<style lang="scss">
.plc-price-list-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  /* ===== 第一部分：标题 ===== */
  .header-section {
    margin-bottom: 24px;
  }

  .page-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: 6px;
  }

  .page-subtitle {
    font-size: 14px;
    color: #909399;
    line-height: 1.4;
  }

  /* ===== 第二部分：搜索区域 ===== */
  .search-section {
    background: #fff;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  /* Tab 栏 */
  .tab-bar {
    display: flex;
    gap: 0;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 16px;
    padding-bottom: 0;
  }

  .tab-item {
    position: relative;
    padding: 10px 20px;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    transition: color 0.2s;
    user-select: none;
  }

  .tab-item:hover {
    color: #ff3176;
  }

  .tab-item.active {
    color: #ff3176;
    font-weight: 600;
  }

  .tab-item.active::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #ff3176;
  }

  .tab-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    min-width: 16px;
    /* height: 16px; */
    padding: 0 5px;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    background-color: #ff3176;
    border-radius: 50px 50px 50px 0;
    line-height: 16px;
    -webkit-transform: translate(50%, -50%);
    transform: translate(50%, -50%);
  }

  /* 搜索表单 */
  .search-form {
    padding-top: 4px;
  }

  .search-form .el-form-item {
    margin-bottom: 0;
  }

  .search-form .el-form-item__label {
    font-size: 13px;
    color: #606266;
  }

  /* 平台 Tab 切换 */
  .platform-tabs {
    .el-form-item__content {
      line-height: 27px;
    }
  }

  /* 定价状态气泡 */
  .status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 5px;
    margin-left: 3px;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    line-height: 16px;
    vertical-align: middle;
  }

  /* ===== 第三部分：表格 ===== */
  .table-section {
    background: #fff;
    border-radius: 8px;
    padding: 16px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .table-section .el-table {
    border-radius: 4px;
  }

  .table-section .el-table th {
    background-color: #fafafa;
    color: #303133;
    font-weight: 600;
  }

  .table-section .el-table__row:hover td {
    background-color: #fff5f8 !important;
  }

  /* 空状态 */
  .empty-state {
    padding: 40px 0;
  }

  /* 分页 */
  .pagination-wrapper {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}

</style>
